import { motion } from "framer-motion";
import { EASE } from "@/components/Reveal";

const TYPEFORM_URL = "https://zss61amb4gz.typeform.com/to/KSkpcSEV";

const LINES = [
  <>Finish 2026</>,
  <>
    with <em className="italic text-white/90">momentum.</em>
  </>,
  <>Start 2027</>,
  <>
    with a <em className="italic text-forest">brand.</em>
  </>,
];

export const Hero = () => {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-ink"
      data-testid="hero-section"
    >
      <div
        className="pointer-events-none absolute -top-40 right-[-10%] h-[540px] w-[540px] rounded-full opacity-25"
        style={{
          background:
            "radial-gradient(circle, rgba(31,77,58,0.55) 0%, rgba(31,77,58,0) 65%)",
        }}
        aria-hidden="true"
      />
      <div className="mx-auto max-w-7xl px-5 pb-16 pt-32 sm:px-8 lg:min-h-screen lg:pb-24 lg:pt-24">
        <div>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.1 }}
            className="mb-8 flex items-center gap-3 text-[11px] uppercase tracking-[0.32em] text-stone"
          >
            <span className="inline-block h-1.5 w-1.5 bg-forest" />
            The Embodied Creator — an 8-week group mentorship
          </motion.p>

          <h1 className="font-mont text-[clamp(2rem,6.2vw,5.8rem)] font-bold leading-[1.08] tracking-[-0.02em] text-bone">
            {LINES.map((line, i) => (
              <span key={i} className="block overflow-hidden pb-1">
                <motion.span
                  className="block"
                  initial={{ y: "115%" }}
                  animate={{ y: 0 }}
                  transition={{
                    duration: 1.1,
                    delay: 0.25 + i * 0.14,
                    ease: EASE,
                  }}
                >
                  {line}
                </motion.span>
              </span>
            ))}
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.95, ease: EASE }}
            className="mt-8 max-w-xl font-mont text-base font-bold leading-relaxed text-white/70 sm:text-lg"
          >
            Build your message, content system, first offer, and sales process
            in 8 weeks — while doing the inner work required to actually put
            yourself out there.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 1.1, ease: EASE }}
            className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center"
          >
            <button
              data-testid="hero-apply-now-button"
              onClick={() => window.open(TYPEFORM_URL, "_blank", "noopener")}
              className="group relative overflow-hidden bg-forest rounded-full px-10 py-5 font-mont text-base font-bold uppercase tracking-[0.16em] text-white transition-colors duration-300 hover:bg-[#2a6b50]"
            >
              Apply now
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 1.3 }}
            className="mt-14 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-white/10 pt-6 font-mont text-[11px] font-bold uppercase tracking-[0.22em] text-stone"
          >
            <span>Starts November 3</span>
            <span className="hidden h-3 w-px bg-white/20 sm:block" />
            <span>8 weeks · live</span>
            <span className="hidden h-3 w-px bg-white/20 sm:block" />
            <span>Small group</span>
            <span className="hidden h-3 w-px bg-white/20 sm:block" />
            <span>First 6 seats — $1,500</span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
